import type { DocMigration } from "../docMigration";

/**
 * Migrates the includedBy field on entityRefs from "entityTag.abcdefgh" to "label.abcdefgh"
 * and updates the type from "ENTITY_TAG" to "LABEL".
 */
const migration: DocMigration = {
  id: "20260331_migrate_entity_refs_to_labels",
  description: "Migrate entity refs to use labels instead of entity tags",
  apply(json: any): any {
    const entityRefs = json.entityRefs ?? {};
    for (const entityRefId of Object.keys(entityRefs)) {
      const entityRef = entityRefs[entityRefId];
      if (entityRef?.entityRefType !== "V2") {
        continue;
      }

      const includedBy = entityRef.includedBy;
      if (typeof includedBy !== "object" || includedBy === null) {
        continue;
      }

      for (const [includedById, includedByValue] of Object.entries(includedBy)) {
        if (typeof includedByValue !== "object" || includedByValue === null) {
          continue;
        }

        if (!("type" in includedByValue) || includedByValue.type !== "ENTITY_TAG") {
          continue;
        }

        delete includedBy[includedById];
        const migratedIncludedById = includedById.startsWith("entityTag.")
          ? includedById.replace("entityTag.", "label.")
          : includedById;
        includedBy[migratedIncludedById] = { ...includedByValue, type: "LABEL" };
      }
    }

    return json;
  },
};

export default migration;
